exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox[data-v-ddb8caf6]{margin:0}\n", ""]);

// exports
